var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAffirmationBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 430,
    height: 430,
    viewBox: "0 0 430 430",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "uvkoglkhka"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#707070",
    d: "M0 0H430V430H0z",
    transform: "translate(0 338)"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#uvkoglkhka)",
    transform: "translate(0 -338)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.05
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M246.736 0C110.692 0 0 110.68 0 246.732s110.692 246.732 246.736 246.732S493.46 382.792 493.46 246.732 382.78 0 246.736 0zm113.788 208.716L230.98 338.268a7.74 7.74 0 0 1-10.64 0l-86.908-86.912a7.477 7.477 0 0 1-2.192-5.324 7.566 7.566 0 0 1 2.192-5.336l11.108-11.1a7.586 7.586 0 0 1 10.644 0l67.752 67.752a3.827 3.827 0 0 0 5.444 0l110.392-110.396a7.745 7.745 0 0 1 10.644 0l11.108 11.124a7.513 7.513 0 0 1 0 10.64z",
    transform: "translate(-120.46 384)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAffirmationBg);
export default __webpack_public_path__ + "static/media/affirmationBg.c361bd49db992024fcdacaf9d8c6089b.svg";
export { ForwardRef as ReactComponent };